import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import Router from "./Router";
import "promise-polyfill/src/polyfill"; // Promise polyfill for IE11 support

ReactDOM.render(<Router />, document.getElementById("root"));
